/**
 * 3D Lite — Gontec-MV web viewer — React entry point.
 *
 * The app is mounted into #root from index.html.  All routing is done
 * inside <App/> (no react-router for now — we parse window.location
 * directly because we only have two view types: project picker vs.
 * viewer for one project).
 */
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'

const root = document.getElementById('root')
if (!root) {
  throw new Error('No #root element in index.html')
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>
)
